/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    InternalApiActiveAlertNoteTemplate,
    InternalApiActiveAlertNoteTemplateFromJSON,
    InternalApiActiveAlertNoteTemplateToJSON,
    InternalApiAlertNoteTemplate,
    InternalApiAlertNoteTemplateFromJSON,
    InternalApiAlertNoteTemplateToJSON,
    InternalApiAlertNoteTemplatePage,
    InternalApiAlertNoteTemplatePageFromJSON,
    InternalApiAlertNoteTemplatePageToJSON,
    InternalApiAlertType,
    InternalApiAlertTypeFromJSON,
    InternalApiAlertTypeToJSON,
    InternalApiCreateAlertNoteTemplateRequest,
    InternalApiCreateAlertNoteTemplateRequestFromJSON,
    InternalApiCreateAlertNoteTemplateRequestToJSON,
    InternalApiSortDirection,
    InternalApiSortDirectionFromJSON,
    InternalApiSortDirectionToJSON,
    InternalApiUpdateAlertNoteTemplateRequest,
    InternalApiUpdateAlertNoteTemplateRequestFromJSON,
    InternalApiUpdateAlertNoteTemplateRequestToJSON,
} from '../models';

export interface CreateAlertNoteTemplateRequest {
    internalApiCreateAlertNoteTemplateRequest: InternalApiCreateAlertNoteTemplateRequest;
}

export interface DeleteAlertNoteTemplateRequest {
    id: number;
}

export interface FindAlertNoteTemplateByIdRequest {
    id: number;
}

export interface FindAlertNoteTemplatesRequest {
    page: number;
    size: number;
    query?: string;
    alertType?: InternalApiAlertType;
    orderBy?: FindAlertNoteTemplatesOrderByEnum;
    direction?: InternalApiSortDirection;
}

export interface FindUsableAlertNoteTemplatesRequest {
    alertType: InternalApiAlertType;
}

export interface UpdateAlertNoteTemplateRequest {
    id: number;
    internalApiUpdateAlertNoteTemplateRequest: InternalApiUpdateAlertNoteTemplateRequest;
}

/**
 * 
 */
export class AlertNoteTemplateInternalApi extends runtime.BaseAPI {

    /**
     * Creates a new alert note template
     */
    async createAlertNoteTemplateRaw(requestParameters: CreateAlertNoteTemplateRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InternalApiAlertNoteTemplate>> {
        if (requestParameters.internalApiCreateAlertNoteTemplateRequest === null || requestParameters.internalApiCreateAlertNoteTemplateRequest === undefined) {
            throw new runtime.RequiredError('internalApiCreateAlertNoteTemplateRequest','Required parameter requestParameters.internalApiCreateAlertNoteTemplateRequest was null or undefined when calling createAlertNoteTemplate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/alert-note-templates`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InternalApiCreateAlertNoteTemplateRequestToJSON(requestParameters.internalApiCreateAlertNoteTemplateRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalApiAlertNoteTemplateFromJSON(jsonValue));
    }

    /**
     * Creates a new alert note template
     */
    async createAlertNoteTemplate(requestParameters: CreateAlertNoteTemplateRequest, initOverrides?: RequestInit): Promise<InternalApiAlertNoteTemplate> {
        const response = await this.createAlertNoteTemplateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Deletes an alert note template
     */
    async deleteAlertNoteTemplateRaw(requestParameters: DeleteAlertNoteTemplateRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling deleteAlertNoteTemplate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/alert-note-templates/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes an alert note template
     */
    async deleteAlertNoteTemplate(requestParameters: DeleteAlertNoteTemplateRequest, initOverrides?: RequestInit): Promise<void> {
        await this.deleteAlertNoteTemplateRaw(requestParameters, initOverrides);
    }

    /**
     * Fetches a single alert note template
     */
    async findAlertNoteTemplateByIdRaw(requestParameters: FindAlertNoteTemplateByIdRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InternalApiAlertNoteTemplate>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling findAlertNoteTemplateById.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/alert-note-templates/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalApiAlertNoteTemplateFromJSON(jsonValue));
    }

    /**
     * Fetches a single alert note template
     */
    async findAlertNoteTemplateById(requestParameters: FindAlertNoteTemplateByIdRequest, initOverrides?: RequestInit): Promise<InternalApiAlertNoteTemplate> {
        const response = await this.findAlertNoteTemplateByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fetches alert note templates with filtering and pagination
     */
    async findAlertNoteTemplatesRaw(requestParameters: FindAlertNoteTemplatesRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InternalApiAlertNoteTemplatePage>> {
        if (requestParameters.page === null || requestParameters.page === undefined) {
            throw new runtime.RequiredError('page','Required parameter requestParameters.page was null or undefined when calling findAlertNoteTemplates.');
        }

        if (requestParameters.size === null || requestParameters.size === undefined) {
            throw new runtime.RequiredError('size','Required parameter requestParameters.size was null or undefined when calling findAlertNoteTemplates.');
        }

        const queryParameters: any = {};

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.size !== undefined) {
            queryParameters['size'] = requestParameters.size;
        }

        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }

        if (requestParameters.alertType !== undefined) {
            queryParameters['alertType'] = requestParameters.alertType;
        }

        if (requestParameters.orderBy !== undefined) {
            queryParameters['orderBy'] = requestParameters.orderBy;
        }

        if (requestParameters.direction !== undefined) {
            queryParameters['direction'] = requestParameters.direction;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/alert-note-templates`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalApiAlertNoteTemplatePageFromJSON(jsonValue));
    }

    /**
     * Fetches alert note templates with filtering and pagination
     */
    async findAlertNoteTemplates(requestParameters: FindAlertNoteTemplatesRequest, initOverrides?: RequestInit): Promise<InternalApiAlertNoteTemplatePage> {
        const response = await this.findAlertNoteTemplatesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fetches usable alert note templates
     */
    async findUsableAlertNoteTemplatesRaw(requestParameters: FindUsableAlertNoteTemplatesRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<InternalApiActiveAlertNoteTemplate>>> {
        if (requestParameters.alertType === null || requestParameters.alertType === undefined) {
            throw new runtime.RequiredError('alertType','Required parameter requestParameters.alertType was null or undefined when calling findUsableAlertNoteTemplates.');
        }

        const queryParameters: any = {};

        if (requestParameters.alertType !== undefined) {
            queryParameters['alertType'] = requestParameters.alertType;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/alert-note-templates/search`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(InternalApiActiveAlertNoteTemplateFromJSON));
    }

    /**
     * Fetches usable alert note templates
     */
    async findUsableAlertNoteTemplates(requestParameters: FindUsableAlertNoteTemplatesRequest, initOverrides?: RequestInit): Promise<Array<InternalApiActiveAlertNoteTemplate>> {
        const response = await this.findUsableAlertNoteTemplatesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Updates an alert note template
     */
    async updateAlertNoteTemplateRaw(requestParameters: UpdateAlertNoteTemplateRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InternalApiAlertNoteTemplate>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateAlertNoteTemplate.');
        }

        if (requestParameters.internalApiUpdateAlertNoteTemplateRequest === null || requestParameters.internalApiUpdateAlertNoteTemplateRequest === undefined) {
            throw new runtime.RequiredError('internalApiUpdateAlertNoteTemplateRequest','Required parameter requestParameters.internalApiUpdateAlertNoteTemplateRequest was null or undefined when calling updateAlertNoteTemplate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/alert-note-templates/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: InternalApiUpdateAlertNoteTemplateRequestToJSON(requestParameters.internalApiUpdateAlertNoteTemplateRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalApiAlertNoteTemplateFromJSON(jsonValue));
    }

    /**
     * Updates an alert note template
     */
    async updateAlertNoteTemplate(requestParameters: UpdateAlertNoteTemplateRequest, initOverrides?: RequestInit): Promise<InternalApiAlertNoteTemplate> {
        const response = await this.updateAlertNoteTemplateRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
    * @export
    * @enum {string}
    */
export enum FindAlertNoteTemplatesOrderByEnum {
    NAME = 'NAME',
    UPDATED_TIME = 'UPDATED_TIME',
    CREATED_TIME = 'CREATED_TIME'
}
